import React, { useState } from 'react'
import { Form, Radio } from 'antd'
import { RadioChangeEvent } from 'antd/lib/radio'
import { useTranslation } from 'lib/i18n'

import { VIDEO_REQUEST_IS_GIFT } from 'components/ProductPage/shared/FieldConstants'
import Option from 'components/UI/Option/Option'
import OptionGroup from 'components/UI/OptionGroup/OptionGroup'

type IsGiftProps = {
  variant?: 'old' | 'new'
  form?: ReturnType<typeof Form.useForm>[0]
}

const IsGift: React.FC<IsGiftProps> = ({ variant = 'old', form }) => {
  const { t } = useTranslation()
  const { getFieldValue, setFieldsValue } = form || {
    getFieldValue: () => null,
    setFieldsValue: () => null,
  }
  const [isGift, setIsGift] = useState<boolean>(
    getFieldValue(VIDEO_REQUEST_IS_GIFT),
  )

  if (variant === 'old') {
    return (
      <Form.Item
        name={VIDEO_REQUEST_IS_GIFT}
        label={t('VideoRequestForm.giftLabel', 'This video is for')}
        required
        data-cy="isGiftRadioGroup"
      >
        <Radio.Group size="large">
          <Radio value>{t('VideoRequestForm.isGift', 'Someone else')}</Radio>
          <Radio value={false}>
            {t('VideoRequestForm.isNotGift', 'Myself')}
          </Radio>
        </Radio.Group>
      </Form.Item>
    )
  }

  const handleOnChange = ({ target: { value } }: RadioChangeEvent) => {
    const currentValue = getFieldValue('VIDEO_REQUEST')

    setFieldsValue({
      VIDEO_REQUEST: {
        ...currentValue,
        isGift: value,
      },
    })

    setIsGift(value)
  }

  return (
    <Form.Item
      name={VIDEO_REQUEST_IS_GIFT}
      required
      data-cy="isGiftRadioGroup"
      shouldUpdate
    >
      <OptionGroup
        title={t('IsGift.toWho', 'Who is this video for?')}
        checkedValue={isGift}
        handleOnChange={handleOnChange}
      >
        <Option name={t('VideoRequestForm.isGift', 'Someone else')} value />
        <Option
          name={t('VideoRequestForm.isNotGift', 'Myself')}
          value={false}
        />
      </OptionGroup>
    </Form.Item>
  )
}

export default IsGift
